<template>
  <v-menu offset-y bottom transition="slide-y-transition">
    <template v-slot:activator="{ on }">
      <v-list-item class="pr-0">
        <v-list-item-avatar size="35" class="fh-pointer mr-2" v-on="on"  color="#f1f8e9">
          <div class="primary--text">{{abreviatura}}</div>
        </v-list-item-avatar>
      </v-list-item>
    </template>
    <v-list dense style="background: #fffffb;">
      <v-list-item>
        <v-list-item-title>{{ nombreOperador }}</v-list-item-title>
      </v-list-item>
      <v-list-item :href="configurationUrl" target="_blank">
        <v-list-item-action>
          <v-icon>mdi-account-cog</v-icon>
        </v-list-item-action>
        <v-list-item-title>Configuraciones</v-list-item-title>
      </v-list-item>
      <v-list-item @click="handleLogout">
        <v-list-item-action>
          <v-icon>mdi-power</v-icon>
        </v-list-item-action>
        <v-list-item-title>Cerrar Sesión</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import SessionService from '@/services/SessionService'
  import {CONFIGURATION_URL, LOGOUT_URL, SITE_NAME} from '@/config'
  import {mapActions} from 'vuex'

  export default {
    name: "FhMenuOperador",
    props: {
      drawer: Boolean
    },
    components: {},
    computed: {
      nombreOperador() {
        return SessionService.getNombreOperador()
      },
      configurationUrl() {
        return CONFIGURATION_URL
      },
      abreviatura(){
        let words = this.nombreOperador.split(' ')
        let abr = ''
        if(words.length <= 3 && words.length >= 2){
          abr = `${words[0][0]}${words[1][0]}`
        }else{
          abr = `${words[0][0]}${words[2][0]}`
        }
        return abr
      }
    },
    methods: {
      ...mapActions('session', [
        'logout'
      ]),
      handleLogout() {
        this.logout()
        location.href = `${LOGOUT_URL}?nombre=${SITE_NAME}&redirect=${location.origin}`
      },
      // handleCambiarEntidad() {
      //   this.$router.push({name: 'ElegirEntidad'}).catch(() => {})
      // },
    },
  }
</script>

<style scoped>
  .fh-pointer {
    cursor: pointer;
  }
</style>
